/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagicWand: {
  name: 'magic-wand';
  data: string;
} = {
  name: 'magic-wand',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8.94 4.354a1.5 1.5 0 0 1 2.12 0l.586.585a1.5 1.5 0 0 1 0 2.122l-1.292 1.292-.001.001-6.292 6.292a1.5 1.5 0 0 1-2.122 0l-.586-.585a1.5 1.5 0 0 1 0-2.122l6.293-6.293L8.94 4.354Zm2 2-.94.939L8.707 6l.94-.94a.5.5 0 0 1 .706 0l.586.586a.5.5 0 0 1 0 .708Zm-8.88 6.292L8 6.707 9.293 8l-5.94 5.94a.5.5 0 0 1-.707 0l-.585-.586a.5.5 0 0 1 0-.708ZM8 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm6 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
